import {
  GET_WITHDRAW_DETAILS_CARD_NOT_FOUND,
  GET_WITHDRAW_DETAILS_FAILED,
  GET_WITHDRAW_DETAILS_INVALID_REQUEST,
  GET_WITHDRAW_DETAILS_NOT_FOUND,
  GET_WITHDRAW_DETAILS_SUCCESS,
  LOADING_GET_WITHDRAW
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  failed: false,
  invalidRequest: false,
  cardNotFound: false,
  success: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_WITHDRAW:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false
      };

    case GET_WITHDRAW_DETAILS_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        success: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false
      };
    case GET_WITHDRAW_DETAILS_CARD_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        cardNotFound: true,
        success: false,
        notFound: false,
        invalidRequest: false,
        failed: false
      };
    case GET_WITHDRAW_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        cardNotFound: false
      };
    case GET_WITHDRAW_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        success: false,
        notFound: false,
        cardNotFound: false
      };
    case GET_WITHDRAW_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false,
        success: true,
        data: action.payload
      };

    default:
      return state;
  }
};
